import React, { useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateHomepageModule } from '../../../../../../../../store/actions/admin/create-event';
import { EventsState } from '../../../../../../../../store/types';
import { HomepageMainEventBanner, PageModule, SessionTypesEnum } from '../../../../../../../../types/working-model';
import Checkbox from '../../../../../../../general-ui/checkbox/checkbox';

interface IMainEventBannerAdvancedLayoutProps {
	module: PageModule;
}

const MainEventBannerAdvancedLayout: React.FC<IMainEventBannerAdvancedLayoutProps> = ({ module }) => {
	const {
		CreateEventReducer: {
			workingEvent
		}
	} = useSelector((event: EventsState) => event);
	const content: HomepageMainEventBanner = module.content;

	//check if the property exists yet
	const isOnInit = useMemo(() => {
		return ("countdownIsOn" in content)
			? content.countdownIsOn
			// backward compatable: check if any session has a broadcast date, then turn on
			: workingEvent?.sessions.some(session => session.session_type === SessionTypesEnum.broadcast);
	}, [content, workingEvent?.sessions]);

	const [isOn, setIsOn] = useState(!!isOnInit);

	const dispatch = useDispatch();


	function toggleCountdown(_: any, _isOn: boolean) {
		setIsOn(_isOn);
		dispatch(
			updateHomepageModule(
				{
					...module,
					content: {
						...module.content,
						countdownIsOn: _isOn
					}
				}
			)
		);
	}

	return (
		<div className="countdown">
			<Checkbox
				checked={isOn}
				value="Count Down"
				onChange={toggleCountdown}
			/>
			<p>Countdown</p>
		</div>
	);
};

export default MainEventBannerAdvancedLayout;
